import { render } from "./OrderListView.vue?vue&type=template&id=65cd6804"
import script from "./OrderListView.vue?vue&type=script&lang=js"
export * from "./OrderListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__